import React, { FunctionComponent, SyntheticEvent, useState } from 'react';
import withStyles from 'react-jss';
import { isEmpty, without } from 'ramda';
import { CheckboxProps, Container, Header } from 'semantic-ui-react';

import Table from 'components/FilterableTable/FilterableTable';
import OnboardVenues from 'components/VenueOnboarding/OnboardSelectedVenues';
import AddMissingVenueModal from 'components/VenueOnboarding/AddMissingVenueModal';
import { useSelectedPlaces } from 'helpers/useSelectedPlaces';
import { ClassProp } from 'helpers/types';

import styles from './MerchantOnboardVenues.styles';
import {
  Place,
  getIdsFromPlaces,
  getOnboardVenuesTableLayout,
} from './MerchantOnboardVenues.helpers';

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  classes: Styles;
  places: Place[];
  addMissingPlace: (newPlace: Place) => void;
  getMore: Function;
};

const RenderMerchantOnboardVenues: FunctionComponent<Props> = ({
  classes,
  places,
  addMissingPlace,
  getMore,
}) => {
  const [allSelected, setAllSelected] = useState<boolean>(false);
  const { selectedPlaces, writeSelectedPlacesCache } = useSelectedPlaces();

  const handleSelectPlace = (
    _: SyntheticEvent<HTMLElement, Event>,
    { value: selectedExternalId, checked: selected }: CheckboxProps,
  ) => {
    let newSelectedPlaces = [];
    if (selected) {
      newSelectedPlaces = [...selectedPlaces, selectedExternalId as string];
    } else {
      newSelectedPlaces = without(
        [selectedExternalId],
        selectedPlaces,
      ) as string[];
    }

    writeSelectedPlacesCache({ data: { selectedPlaces: newSelectedPlaces } });
  };

  const handleSelectAllPlaces = (
    _: SyntheticEvent<HTMLElement, Event>,
    { checked: selectedAll }: CheckboxProps,
  ) => {
    const selectAllPlaces = selectedAll ? getIdsFromPlaces(places) : [];
    writeSelectedPlacesCache({ data: { selectedPlaces: selectAllPlaces } });
    setAllSelected(selectedAll as boolean);
  };

  const HandleAddMissingPlace = (newVenue: Place, venueId: string) => {
    addMissingPlace(newVenue);
    writeSelectedPlacesCache({
      data: { selectedPlaces: [...selectedPlaces, venueId] },
    });
  };

  return (
    <Container className={classes.container}>
      {isEmpty(places) && (
        <Header as="h3">
          No locations where found! Please refine your search above or enter it
          in manually
        </Header>
      )}
      <Table
        tableLayout={getOnboardVenuesTableLayout(
          classes,
          selectedPlaces,
          handleSelectPlace,
          handleSelectAllPlaces,
          allSelected,
        )}
        data={places}
      />
      <div className={classes.buttonContainer}>
        <AddMissingVenueModal onAddPlace={HandleAddMissingPlace} />
        <OnboardVenues places={places} placeIds={selectedPlaces} />
      </div>
    </Container>
  );
};

export default withStyles(styles)(RenderMerchantOnboardVenues);
